import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';

import { DASHBOARD_DATA_SETS } from 'constants/dashboard';
import { getDataSetsList } from 'helper/getDatasetList';
import { useBreakpointFlags } from 'hooks/useBreakpointFlags';
import { DatePicker, Select } from 'components/simple';

const styles = {
  container: ({ breakpoints, palette }) => ({
    position: 'relative',
    width: '100%',
    backgroundColor: palette.text.primary,
    paddingBlock: 1.5,
    paddingInline: 0.5,
    borderRadius: 4,
    [breakpoints.up('sm')]: {
      padding: 4,
    },
    [breakpoints.up('md')]: {
      maxWidth: 480,
    },
  }),
  dateColumn: {
    flex: 1,
    minWidth: 0,
  },
};

const Filter = ({
  title = 'Timeframe',
  dataSets = {},
  customStyles,
  limits,
  limitFilter,
  onChangeLimitFilter,
  selectedDataSet,
  setSelectedDataSet,
  ...rest
}) => {
  const { isMdDown: isMobile } = useBreakpointFlags();

  const datasetList = getDataSetsList(dataSets, true);

  return (
    <Stack spacing={2} sx={styles.container}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <Typography variant="subtitle1" color="white">
          {title}
        </Typography>

        <Select onChange={setSelectedDataSet} options={datasetList} value={selectedDataSet} />
      </Stack>
      <Stack spacing={2} direction="row">
        <Stack spacing={1} sx={styles.dateColumn}>
          <Typography variant="caption" color="primary">
            From date
          </Typography>

          <DatePicker
            disabled={selectedDataSet !== DASHBOARD_DATA_SETS.CUSTOM}
            onChange={(val) => onChangeLimitFilter(val, limitFilter.date_to)}
            value={limitFilter.date_from}
            minDate={limits.date_from}
            maxDate={limitFilter.date_to}
            {...rest}
          />
        </Stack>

        <Stack spacing={1} sx={styles.dateColumn}>
          <Typography variant="caption" color="primary">
            To date
          </Typography>

          <DatePicker
            disabled={selectedDataSet !== DASHBOARD_DATA_SETS.CUSTOM}
            onChange={(val) => onChangeLimitFilter(limitFilter.date_from, val)}
            value={limitFilter.date_to}
            minDate={limitFilter.date_from}
            maxDate={limits.date_to}
            popperPlacement={isMobile ? 'bottom-end' : 'bottom-start'}
            {...rest}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

Filter.propTypes = {
  title: PropTypes.string,
  dataSets: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.objectOf(PropTypes.string),
      PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
    ]),
  ),
  customStyles: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]),
  limits: PropTypes.shape({
    date_from: PropTypes.string,
    date_to: PropTypes.string,
  }).isRequired,
  limitFilter: PropTypes.shape({
    date_from: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    date_to: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  }).isRequired,
  onChangeLimitFilter: PropTypes.func.isRequired,
  selectedDataSet: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setSelectedDataSet: PropTypes.func.isRequired,
};
export default Filter;
